import { useState, type ReactNode } from 'react';
import { Icon, ICON_SIZE } from '../chrome/icons';
import { IconButton } from '../../ui/controls';
import { Popover, useAnchor } from '../../ui/popover';

/** The field over a list that narrows it by name. */
export function SearchField({ value, onChange, label }: { value: string; onChange: (value: string) => void; label: string }) {
  return (
    <label className="library-search field-focus mx-[12px] mb-[10px] flex h-[34px] shrink-0 items-center gap-[8px] rounded-[10px] bg-fill-2 px-[10px] text-label-3">
      <Icon name="search" size={ICON_SIZE.control} />
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={label}
        aria-label={label}
        className="w-0 min-w-0 flex-1 bg-transparent text-[13px] text-label outline-none placeholder:text-label-3"
      />
    </label>
  );
}

/** One search/filter layout for catalogue items, Drive media and project folders. */
export function LibraryFilters({ query, onQuery, searchLabel, filterLabel, dialogLabel, count = 0, onReset, children }: {
  query: string;
  onQuery: (query: string) => void;
  searchLabel: string;
  filterLabel: string;
  dialogLabel: string;
  count?: number;
  onReset: () => void;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useAnchor<HTMLButtonElement>();
  return <>
    <div className="catalog-search-row">
      <SearchField value={query} onChange={onQuery} label={searchLabel} />
      <button ref={setAnchor} type="button" className="catalog-filter-button" aria-label={filterLabel} aria-expanded={open} onClick={() => setOpen(was => !was)}>
        <Icon name="filter" size={ICON_SIZE.control} />
        {count > 0 && <span className="catalog-filter-count">{count}</span>}
      </button>
    </div>
    <Popover open={open} anchor={anchor} onClose={() => setOpen(false)} align="end" width={280} label={dialogLabel} ownsKeyboard className="catalog-filters">
      <header><h3>Filters</h3><IconButton icon="close" label={`Close ${dialogLabel.charAt(0).toLowerCase()}${dialogLabel.slice(1)}`} onClick={() => setOpen(false)} /></header>
      {children}
      <footer><button type="button" disabled={!count} onClick={onReset}>Reset filters</button><button type="button" onClick={() => setOpen(false)}>Done</button></footer>
    </Popover>
  </>;
}
